import './assets/scss/styles.scss';
import router from './router';
import Vue from 'vue';

new Vue({ router: router }).$mount('#root');
